// /src/utils/resource.js
const resource = (imageRelativePath = '') => {
    // 確保 imageRelativePath 以 "/" 開頭，避免重複的 "/"
    const baseUrl = window._env_.REACT_APP_GD_SYSHUB_BASE_URL;
    return imageRelativePath.startsWith('/') ? `${baseUrl}${imageRelativePath}` : `${imageRelativePath}`;
}

export default resource;
